













































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { nickname } from '@/utils/nickname'
import { getBoUrl } from '@/api/http-constants'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        Avatar,
    },
})
export default class ProfilMenu extends Vue {
    @Prop({ type: Boolean, default: false }) onlyShowDisconnect

    get name() {
        return nickname(
            UserModule.userInfos.firstname,
            UserModule.userInfos.lastname
        )
    }

    get userId() {
        return UserModule.userInfos.id
    }

    get imagePath() {
        const p = UserModule.userInfos.imagePath
        return p ? getBoUrl() + p : null
    }

    logout() {
        UserModule.LogOut().then(response => {
            this.$router.push({ name: 'signin' })
        })
    }
}
